<template>
    <v-card class="wost-expanded-content" :elevation="5">
        <v-card-text class="wost-customer-detail">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-text class="padding-bootom-0">
                                <span>Entregas realizadas</span>
                            </v-card-text>
                            <v-card-text class="padding-top-0">
                                <v-simple-table height="162px" class="wost-table-detail">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Orden</th>
                                            <th class="text-right">Monto</th>
                                            <th class="text-left">Fecha</th>
                                            <th class="text-left">Tiempo de entrega</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="delivery in deliveries" :key="delivery.number">
                                            <td>{{ delivery.number }}</td>
                                            <td class="text-a-right">{{ delivery.amount | currency('S/') }}</td>
                                            <td>{{ delivery.date | moment("MMM DD, YYYY") }}</td>
                                            <td>{{ delivery.time_delivery }} minutos</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'MobilityDetail',
    props: ['mobility'],
    data() {
        return {
            deliveries: []
        }
    },
    methods: {
        getDeliveries() {
            for (let i = 1; i <= 5; i++) {
                let delivery = {
                    number: '000' + i,
                    amount: 25 * i,
                    date: '2019-12-0' + i,
                    time_delivery: Math.floor((Math.random() * (50-20))+20)
                }
                this.deliveries.push(delivery)
            }
        }
    },
    mounted() {
        this.getDeliveries()
    }
}
</script>

<style>

</style>